<script setup lang="ts">
withDefaults(defineProps<{ link?: boolean, sx?: boolean, black?: boolean }>(), { link: true, sx: false, black: true });

const { locale: localeI18n } = useI18n();
</script>

<template>
  <NuxtLink v-if="link" class="logo" :href="`/${localeI18n}`" aria-label="SX.ORG Logo - перейти на главную страницу">
    <img v-if="black" src="/sx/logo-black.svg" alt="SX.ORG Logo" loading="lazy" decoding="async" height="44" width="132" />
    <img v-else src="/sx/Logo_white.svg" alt="SX.ORG Logo" loading="lazy" decoding="async" height="20" width="100" />
  </NuxtLink>

  <div v-else class="logo" role="img" aria-label="SX.ORG Logo">
    <img v-if="black" src="/sx/logo-black.svg" alt="SX.ORG Logo" loading="lazy" decoding="async" height="44" width="132" />
    <img v-else src="/sx/Logo_white.svg" alt="SX.ORG Logo" loading="lazy" decoding="async" height="20" width="100" />
  </div>
</template>

<style lang="scss" scoped>
.logo {
  display: flex;
  justify-content: center;
  max-width: 132px;
  min-width: 132px;
  height: 44px;
  max-height: 44px;

  @media (max-width: 1399px) {
    min-width: unset;
  }

  img {
    width: 100%;
    object-fit: contain;
  }
}
</style>
